import { useContext } from 'react';
import { store } from '../store';
import { usePostRequest } from '../../core/coreUseRequest';

/** useDeletePayment ::  {} */
export default function useDeleteInvoices() {
	const { dispatch } = useContext(store);

	return usePostRequest({
		url: '/delete/product/invoice/',
		queryName: 'getClientInvoices',
		dispatch,
		successFn: () =>
			dispatch({
				type: 'close dialog'
			})
	});
}
